import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,



}
from 'mdb-react-ui-kit';
import '../../../css/index.css';
import SearchBar from '../../searchBar/searchBar';



function CriarRelacionamentoResponsavel() {

  const tipo = {
    turma: "turma",
    responsavel: "responsavel",
    filial: "filial",
    nomealuno: "nomealuno"
  }


  const navigate = useNavigate();

  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const obj = util.decideBody(userLogin)
  const api = require('../../../apis/relacionamento-responsavel')
  const apiAluno = require('../../../apis/aluno')
  const apiResponsavel = require('../../../apis/responsavel')
  

  const [filterResponsavel, setFilterResponsavel] = useState([]);
  const [inputResponsavel, setInputResponsavel] = useState();
  const [inputIDResponsavel, setinputIDResponsavel] = useState();
  const [dataResponsavel, setDataResponsavel] = useState();

  const [filterAluno, setFilterAluno] = useState([]);
  const [inputAluno, setInputAluno] = useState();
  const [inputIDAluno, setinputIDAluno] = useState();
  const [dataAluno, setDataAluno] = useState();

  const [formValue, setFormValue] = useState({
    idResponsavel: inputIDResponsavel,
    aluno: inputIDAluno,
    idFilial: userLogin.idfilial,
    idEscola: userLogin.idescola,
  });

  const onChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };


  const handleSubmit = async (values) => {
    const obj = {
      idResponsavel: inputIDResponsavel,
      aluno: inputIDAluno,
      idFilial: userLogin.idfilial,
      idEscola: userLogin.idescola,
    };
    values.preventDefault();
    util.isSubmitting()
    const result = await api.registrarResponsavelApi(obj);
    result ? toast.success("Criado com sucesso!") && navigate("/area-relacionamento-responsavel") : null;
    util.isSubmitting()
    
  }


  const handleClickResponsavel = (e) => {
    setInputResponsavel(e.nomeres);
    setinputIDResponsavel(e.cpf)
    setFilterResponsavel([])
  }

  const handleClickAluno = (e) => {
    setInputAluno(e.nomealuno);
    setinputIDAluno(e.ra)
    setFilterAluno([])
  }


  const handleOnChangeAluno = (e) => {
    try{
      if (inputAluno == ""){
        setFilterAluno([])
      }
      setInputAluno(e.target.value);
      const newFilter = dataAluno.filter(value =>{
        return value.nomealuno.toLowerCase().includes(inputAluno.toLowerCase())
      });
      setFilterAluno(newFilter);
    }catch(e){
      toast.error(e);
    }
  }
  
  
  const handleOnChangeResponsavel = (e) => {
    try{
      if (inputResponsavel == ""){
        setFilterResponsavel([])
      }
      setInputResponsavel(e.target.value);
      const newFilter = dataResponsavel.filter(value =>{
        return value.nomeres.toLowerCase().includes(inputResponsavel.toLowerCase())
      });
      setFilterResponsavel(newFilter);
    }catch(e){
      toast.error(e);
    }
  }

  useEffect(() => {
    const getStudents = async () => {
      try {
        const response = await apiAluno.listarAlunoApi(obj);
        const data = await response;
        setDataAluno(data);
        
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };

    const getResponsible = async () => {
      try {
        const obj = {
          idFilial: userLogin.idfilial,
          idEscola: userLogin.idescola
        }
        const response = await apiResponsavel.listarTodosResponsaveisApi(obj);
        const data = await response;
        setDataResponsavel(data);
        
      } catch (error) {
        console.error('Erro ao obter dados:', error);
      }
    };

    getResponsible();
    getStudents();
    
  }, []);

  useEffect(()=>{
    if(inputResponsavel === ""){
      setinputIDResponsavel();
      setFilterResponsavel([]);
    }
    if(inputAluno === ""){
      setinputIDAluno();
      setFilterAluno([]);
    }
  }, [inputResponsavel,inputAluno])
  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
      height:"100vh", minHeight:'500px',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column align-items-center'>

          <MDBCard className='bg-dark text-white h-75 w-75' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-5'>Bem vindo, {util.decideName(userLogin)}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={handleSubmit}>
                  <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'40%'}} feedback='Por favor digite o nome do responsavel!' invalid>
                        <MDBInput 
                          wrapperClass='mb-1 w-100' 
                          labelClass='text-white' 
                          label='Nome do responsavel' id='formControNomeResponsavel' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='nomeResponsavel'
                          value={inputResponsavel || ''}
                          onChange={handleOnChangeResponsavel}
                          
                          required
                          minLength={3}
                          
                          />
                        {filterResponsavel !== 0 &&<SearchBar data={filterResponsavel} handleClick={handleClickResponsavel} tipo={tipo.responsavel}/>}
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'40%', opacity:0.4}} feedback='Por favor digite o CPF!' invalid>
                        <MDBInput 
                          className='bg-dark'
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='CPF' id='formControCPF' 
                          disabled={true}
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='cpf'
                          value={inputIDResponsavel || ''}
              
                          
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      
    
                      </div>
                      <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'40%'}} feedback='Por favor digite o nome do aluno!' invalid>
                        <MDBInput 
                          wrapperClass='mb-1 w-100' 
                          labelClass='text-white' 
                          label='Nome do aluno' id='formControNomeAluno' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='nomeAluno'
                          value={inputAluno || ''}
                          onChange={handleOnChangeAluno}
                          
                          required
                          minLength={3}
                          
                          />
                        {filterAluno !== 0 &&<SearchBar data={filterAluno} handleClick={handleClickAluno} tipo={tipo.nomealuno}/>}
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'40%', opacity:0.4}} feedback='Por favor digite o RA!' invalid>
                        <MDBInput 
                          className='bg-dark'
                          wrapperClass='mb-1 w-100' 
                          labelClass='text-white' 
                          label='RA' id='formControRA' 
                          type='text' 
                          size="lg" 
                          style={{color:"white"}}
                          name='ra'
                          value={inputIDAluno || ''}
                          
                          
                          required
                          disabled={true}
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      
    
                      </div>
                      
                      <MDBBtn 
                        outline 
                        className='px-5 mt-5 w-100 btn-home' 
                        color='white' 
                        size='lg'
                        type='submit'   
                        id='submitForm'  
                        //disabled={formValue.senha.length < 3 || formValue.nomeAdministrador.length < 1 || formValue.login.length < 1}                 
                        >
                        
                        Registrar
                      </MDBBtn>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/area-relacionamento-responsavel")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default CriarRelacionamentoResponsavel;